import axios from "axios";

import {
  ResponseItem,
  ResponseList,
  ResponseRemove,
} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import {EQSuggestion, suggestionParam} from "../../models/serverModels/report/EQSuggestion";

const rootApi = process.env.REACT_APP_API_KEY;

const suggestion = axios.create({
  baseURL: rootApi,
});

export const getList = async (params: suggestionParam): Promise<ResponseList<EQSuggestion>> =>
  suggestion({
    url: "/SuggestionList",
    method: "get",
    params,
  }).then((res) => res.data);

export const getItem = async (params: Params.GetItem): Promise<ResponseItem<EQSuggestion>> =>
  suggestion({
    url: `/Suggestion/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);

export const create = async (
  params: Params.Create<EQSuggestion>
): Promise<ResponseItem<EQSuggestion>> =>
  suggestion({
    url: `/Suggestion`,
    method: "post",
    data: params,
  }).then((res) => res.data);

export const remove = async (params: Params.Remove): Promise<ResponseRemove> =>
  suggestion({
    url: `/Suggestion/${params.id}`,
    method: "delete",
    data: params,
  }).then((res) => res.data);

export const update = async (
  params: Params.Update<EQSuggestion>
): Promise<ResponseItem<EQSuggestion>> =>
  suggestion({
    url: `/Suggestion/${params.id}`,
    method: "put",
    data: params,
  }).then((res) => res.data);

// note 최고 관리자용 API

export const getAll = async (params: suggestionParam): Promise<ResponseList<EQSuggestion>> =>
  suggestion({
    url: "/SuggestionListAll",
    method: "get",
    params,
  }).then((res) => res.data);

export const read = async (params: Params.GetItem): Promise<ResponseItem<EQSuggestion>> =>
  suggestion({
    url: `/ReadSuggestion/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);

export const complete = async (
  params: Params.Update<EQSuggestion>
): Promise<ResponseItem<EQSuggestion>> =>
  suggestion({
    url: `/CompleteSuggestion/${params.id}`,
    method: "put",
    data: params,
  }).then((res) => res.data);
